import { render, staticRenderFns } from "./basketball-player-stats.vue?vue&type=template&id=6474cc96&scoped=true&"
import script from "./basketball-player-stats.vue?vue&type=script&lang=js&"
export * from "./basketball-player-stats.vue?vue&type=script&lang=js&"
import style0 from "./basketball-player-stats.vue?vue&type=style&index=0&id=6474cc96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6474cc96",
  null
  
)

export default component.exports